<template>
    <div>        
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.cityName" placeholder="城市名称" size="small"></el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.provinceCode" placeholder="不限制省份" clearable size="small">
				        <el-option v-for="(item,index) in province" :key="index" :value="item.id" :label="item.name"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.homeDisplay" placeholder="请选择" size="small">
                        <el-option label="仅看显示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="0"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isHot" placeholder="请选择" size="small">
				        <el-option label="仅查看热门的" :value="1"></el-option>
				        <el-option label="仅查看非热门的" :value="0"></el-option>
				        <el-option label="不限制是否热门" value=""></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.sort" placeholder="请选择" size="small">
				        <el-option label="优先展示销售中演出更多的" :value="1"></el-option>
				        <el-option label="优先展示热门序位靠前的" :value="2"></el-option>				        
				    </el-select>
				</el-col>				
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">            
			<el-button
			     v-if="$utils.have('/city/getHotCityList')" 
			    type="primary"
			    icon="el-icon-sort"
			    @click="$refs.CitySort.show()"
			    size="small"
			    >热门城市排序
			</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="fetchLoading"
                size="small"
                stripe
            >                
                <el-table-column label="状态">                    
					<template slot-scope="scope">
					    <el-tag v-if="scope.row.homeDisplay == 1" type="success" size="mini">显示</el-tag>
					    <el-tag v-else type="info" size="mini">隐藏</el-tag>
					</template>
                </el-table-column>
                <el-table-column prop="province" label="省份"></el-table-column>
				<el-table-column prop="name" label="城市"></el-table-column> 
                <el-table-column label="城市图片">
                    <template slot-scope="scope">
						<span v-if="scope.row.photo" ><el-image :src="scope.row.photo | coverImage(120,120)" fit="cover" :preview-src-list="[scope.row.photo]"></el-image></span>
                    </template>
                </el-table-column>
                <el-table-column label="城市简介" prop="description" show-overflow-tooltip min-width="150"></el-table-column>               
                <el-table-column label="是否热门">
					<template slot-scope="scope">
					    <p v-if="scope.row.isHot === 1">是</p>
					    <p v-else-if="scope.row.isHot === 0">否</p>
					</template>					
				</el-table-column>
				<el-table-column prop="hotSort" label="热门序位"></el-table-column>
				<el-table-column prop="activityNum" label="销售中演出"></el-table-column>
				<el-table-column prop="nearbyCityName" label="附近城市"></el-table-column>				
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button                            
                            type="text"
                            size="small"
                            icon="el-icon-edit"
							v-if="$utils.have('/city/addOrUpdate')"
							@click="edit(scope.row.id)"
                            >管理</el-button
                        >
                        <el-button
							v-if="$utils.have('/city/hotCity')"
                            type="text"
                            size="small"                 
                            icon="el-icon-sort"        
							@click="setHot(scope.row.id)"
                            >
							<span v-if="scope.row.isHot === 1">取消热门城市</span>
							<span v-else>设为热门城市</span>
							</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="tableData.length > 0" class="page-pagination-box">
            <el-pagination
                background
                @size-change="search"
                @current-change="fetch"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="totalCount || 0">
            </el-pagination>
        </div>
		<city-sort ref="CitySort" @update="fetch()"></city-sort>
		<city-edit ref="CityEdit" @update="fetch()"></city-edit>
    </div>
</template>

<script>
import {fetchProvince} from '@/assets/js/commonApi'
import CitySort from './components/city-sort';
import CityEdit from './components/city-edit';
const defaultQuery = {
    pageNo: 1,
    pageSize: 15,
    cityName: '',	
    homeDisplay: '',
    isHot: '',
    sort: 1,   
    provinceCode:'',
	
};
export default {
    components: {
       CitySort,CityEdit
    },
    data() {
        return {
            params:{
                ...defaultQuery,               
            },
            fetchLoading: false,
            tableData: [],
            totalCount: 0,
			province:[],
			city:[],
        };
    },
	created(){
	    this.getProvince();
	    if( this.params.provinceCode ){
	        this.getCityList(this.params.cityCode);
	    }
	},
    mounted(){
        this.fetch();
    },
    methods: {
        async fetch() {
            this.fetchLoading = true;
            const response = await this.$request({
                url: "/city/getPageList",
                method: "POST",
                data: {
                    ...this.params                    
                },
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.tableData = result.result;
            this.totalCount = result.totalCount;
        },
		//获取所有省份
		async getProvince(){
		    const res = await fetchProvince({}).catch(() => {});
		    const{ state, result} = res.data;
		    if( state == 1 ){
		        this.province = result;
		    }
		},		
		setHot(id){
			this.fetchLoading = true;
			this.$request({
			   url: '/city/hotCity',
			   method: "POST",
			   params: {
				   id:id		   
			   },
		   }).then(res=>{
			   const {state, msg} = res.data;
			   if (state == 1) {
				   this.$message.success('操作成功');
				   this.fetch();
				   
			   } else {				  
				   this.$message.error(msg || "请求失败");
			   }
		   }).finally(()=>{
			   this.fetchLoading = false;
		   }) 
		},
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.params = {...defaultQuery};
            this.search();
        },
		//新增事件
		add(){
		    this.$refs.CityEdit.show();
		},
		//编辑事件
		edit(id) {
		    this.$refs.CityEdit.show(id);
		}
    },
};
</script>
